/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from '../../API';
import * as CUSTOMAPITypes from './API';

type GeneratedQuery<InputType, OutputType> = string & {
  __generatedQueryInput: InputType;
  __generatedQueryOutput: OutputType;
};

export const getPartyMasterAccountWiseCustom = /* GraphQL */ `query GetPartyMasterAccountWise($accountsid: Int!) {
  getPartyMasterAccountWise(accountsid: $accountsid) {
    partyid
    companyid
    companybranchid
    enteredtimestamp
    expiredtimestamp
    partytypecd
    partydisplayname
    partylegalname
    groupaccountid
    gstcategory
    placeofsupply
    entity
    email
    contactnumber
    whatsappnumber
    accountsid
    is_active
    msmetype
    deliveryconsigneename
    deliveryconsigneegstin
    statuscode
    statusmessage
    relatedpartygstdetails {
      gstin
      statuscode
      statusmessage
      __typename
    }
    relatedpartycreditdetails {
      creditperiodduration
      billingcurrency
      creditlimitcd
      creditlimitamount
      statuscode
      statusmessage
      __typename
    }
    lastupdatedby
    tdspercentage
    tdssection
    __typename
  }
}
` as GeneratedQuery<APITypes.GetPartyMasterAccountWiseQueryVariables, CUSTOMAPITypes.CustomGetPartyMasterAccountWiseQuery>;

export const listAccountGroupMasterCustom = /* GraphQL */ `query ListAccountGroupMaster {
  listAccountGroupMaster {
    accountgroupid
    companyid
    companybranchid
    enteredtimestamp
    expiredtimestamp
    accounttypecd
    accountgroupname
    accountparentgroupid
    displayordernumber
    statuscode
    statusmessage
    restrictedflag
    is_active
    path
    __typename
  }
}
` as GeneratedQuery<APITypes.ListAccountGroupMasterQueryVariables, APITypes.ListAccountGroupMasterQuery>;

export const getBankDetailsByAccountNameCustom = /* GraphQL */ `query GetBankDetailsByAccountName($accountname: String!) {
  getBankDetailsByAccountName(accountname: $accountname) {
    bankdetailsid
    companyid
    companybranchid
    objecttype
    enteredtimestamp
    expiredtimestamp
    objectid
    userid
    bankname
    bankaccountnumber
    ifsccode
    branch
    notes
    ledgeraccount
    bankaccounttype
    cash
    swiftcode
    statuscode
    statusmessage
    upi
    __typename
  }
}
` as GeneratedQuery<APITypes.GetBankDetailsByAccountNameQueryVariables, CUSTOMAPITypes.CustomGetBankDetailsByAccountNameQuery>;

export const getCustomPartyMaster = /* GraphQL */ 
`query GetPartyMaster($partyid: Int!) {
  getPartyMaster(partyid: $partyid) {
    partyid
    email
    partydisplayname
    accountsid
    partylegalname
    enteredtimestamp
    partytypecd
    groupaccountid
    comments
    contactnumber
    deliveryconsigneegstin
    deliveryconsigneename
    entity
    gstcategory
    placeofsupply
    is_active
    msmetype
    whatsappnumber
    sameaddressflag
    tdspercentage
    tdssection
    udhyamregno
  }
}
` as GeneratedQuery<APITypes.GetPartyMasterQueryVariables, CUSTOMAPITypes.CustomGetPartyMasterQuery>;
